import { CtrlProps } from "@yuigoto/ctrl";
import { AddressControl } from "controls/AddressControl";

/**
 *
 * @param {CtrlProps[]} controls
 * @returns {CtrlProps[]}
 */
const toBillingAddress = (controls) => {
  for (let n = 0; n < controls.length; n++) {
    let name = controls[n].name;

    name = `billing${name.substr(0,1).toUpperCase()}${name.substr(1)}`;

    controls[n].name = name;
  }

  return controls;
};

/**
 * @type {CtrlProps[]}
 */
const BillingAddressControl = toBillingAddress(AddressControl);

export {
  BillingAddressControl
};
